import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { City, CreateCityDto, SearchCityDto, UpdateCityDto } from 'src/typings';
import { AuthService } from '../login/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  create(payload: CreateCityDto) {
    return this.http.post(`${environment.BACKEND}/city/create`, payload);
  }

  update(payload: UpdateCityDto) {
    return this.http.put(`${environment.BACKEND}/city/update`, payload);
  }

  getOne(id: number) {
    return this.http.get(`${environment.BACKEND}/city/${id}`);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/city/${id}`);
  }

  search(payload?: SearchCityDto) {
    return this.http.post<{ data: City[]; length: number }>(
      `${environment.BACKEND}/city/search`,
      payload
    );
  }
}
